// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme
import { layers } from '@atlaskit/theme/constants';

export const zIndex: {
	searchDialog: 300;
} = {
	searchDialog: layers.dialog(),
};
